import { $t } from "helpers/translator"

const AddStaffMember = {
    steps: [
        {
            target: '#addStaffButton',
            title: $t('global.tours.AddStaffMember.0.title'),
            content: $t('global.tours.AddStaffMember.0.content'),
            clickToContinue: true
        },
        {
            target: '#addStaffMemberModal',
            title: $t('global.tours.AddStaffMember.1.title'),
            content: $t('global.tours.AddStaffMember.1.content'),
            waitForElement: true,
            locale: {
                last: $t('global.tours.AddStaffMember.1.confirm')
            }
        },
    ],
    url: '/staff'
}

export default AddStaffMember